export const FETCH_CUSTOMER_CREDIT_REQUEST = 'FETCH_CUSTOMER_CREDIT_REQUEST';
export const FETCH_CUSTOMER_CREDIT_SUCCESS = 'FETCH_CUSTOMER_CREDIT_SUCCESS';
export const FETCH_CUSTOMER_CREDIT_FAILURE = 'FETCH_CUSTOMER_CREDIT_FAILURE';

export const fetchCustomerCreditRequest = customerId => ({
  type: FETCH_CUSTOMER_CREDIT_REQUEST,
  payload: { customerId }
});

export const fetchCustomerCreditSuccess = response => ({
  type: FETCH_CUSTOMER_CREDIT_SUCCESS,
  payload: response
});

export const fetchCustomerCreditFailure = err => ({
  type: FETCH_CUSTOMER_CREDIT_FAILURE,
  payload: err,
  error: true
});



// WEBPACK FOOTER //
// ./src/store/customerCredit/actions.js